import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TextMaskModule } from 'angular2-text-mask';
import { ClickOutsideModule } from 'ng-click-outside';
import { ScrollbarModule } from 'ngx-scrollbar';
import { LsqAutocompleteComponent } from './components/forms/autocomplete/lsq-autocomplete.component';
import { BaseFormControlComponent } from './components/forms/base-form-control.component';
import { LsqCheckboxComponent } from './components/forms/checkbox/lsq-checkbox.component';
import { LsqChecklistComponent } from './components/forms/checklist/lsq-checklist.component';
import { LsqCurrencyInputComponent } from './components/forms/currency-input/lsq-currency-input.component';
import { LsqForm } from './components/forms/form/lsq-form.component';
import { TagInputComponent } from './components/forms/tag-input/tag-input.component';
import { LsqInputComponent } from './components/forms/input/lsq-input.component';
import { LsqRadioListComponent } from './components/forms/radio-list/lsq-radio-list.component';
import { LsqRadioComponent } from './components/forms/radio/lsq-radio.component';
import { LsqSelectComponent } from './components/forms/select/lsq-select.component';
import { LsqSwitchComponent } from './components/forms/switch/lsq-switch.component';
import { LsqTextAreaComponent } from './components/forms/textarea/lsq-textarea.component';
import { LsqDynamicFormComponent } from './components/pages/dynamic-form/lsq-dynamic-form.component';
import { CalendarDayComponent } from './components/ui-elements/date-picker/calendar/calendar-day/calendar-day.component';
import { CalendarDaysGridComponent } from './components/ui-elements/date-picker/calendar/calendar-days-grid/calendar-days-grid.component';
import { CalendarMonthComponent } from './components/ui-elements/date-picker/calendar/calendar-month/calendar-month.component';
import { CalendarMonthsGridComponent } from './components/ui-elements/date-picker/calendar/calendar-months-grid/calendar-months-grid.component';
import { CalendarComponent } from './components/ui-elements/date-picker/calendar/calendar.component';
import { DatePickerComponent } from './components/ui-elements/date-picker/date-picker.component';
import { LsqDateSelectComponent } from './components/ui-elements/date-select/lsq-date-select.component';
import { LsqDropdownComponent } from './components/ui-elements/dropdown/lsq-dropdown.component';
import { LsqCoreModule } from './core';
import { EmailI18nValidator } from './validators/email.validator.i18n';
import { LsqValidators } from './validators/lsq-validators';
import { NumberI18nValidator } from './validators/number.validator.i18n';
import { PasswordI18nValidator } from './validators/password.validator.i18n';
import { PhoneI18nValidator } from './validators/phone.validator.i18n';
import { StringI18nValidator } from './validators/string.validator.i18n';
import { LsqLabelComponent } from './components/ui-elements/label/lsq-label.component';
import { LsqMultiSelectComponent } from './components/forms/multi-select/lsq-multi-select.component';
import { LsqPhoneInputComponent } from './components/forms/phone-input/lsq-phone-input.component';
import { BaseInputComponent } from './components/forms/input/base-input.component';
import { SingleDateInputComponent } from './components/forms/single-date-input/single-date-input.component';
import { DateInputComponent } from './components/forms/date-input/date-input.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxMaskModule } from 'ngx-mask';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

export * from './constants/form.constants';

// Components
export {
    BaseFormControlComponent,
    BaseInputComponent,
    LsqCheckboxComponent,
    SingleDateInputComponent,
    DateInputComponent,
    LsqChecklistComponent,
    LsqCurrencyInputComponent,
    LsqInputComponent,
    TagInputComponent,
    LsqRadioListComponent,
    LsqRadioComponent,
    LsqSelectComponent,
    LsqMultiSelectComponent,
    LsqPhoneInputComponent,
    LsqSwitchComponent,
    LsqTextAreaComponent,
    LsqDynamicFormComponent,
    CalendarDayComponent,
    CalendarDaysGridComponent,
    CalendarMonthComponent,
    CalendarMonthsGridComponent,
    CalendarComponent,
    DatePickerComponent,
    LsqDateSelectComponent,
    LsqDropdownComponent,
    LsqValidators,
    NumberI18nValidator,
    StringI18nValidator,
    PhoneI18nValidator,
    EmailI18nValidator,
    PasswordI18nValidator,
    LsqAutocompleteComponent,
    LsqLabelComponent
};

@NgModule({
    imports: [
        LsqCoreModule.forChild(),
        // Angular modules
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        // Feature modules
        ScrollbarModule,
        ClickOutsideModule,
        TextMaskModule,
        MatDatepickerModule,
        MatInputModule,
        MatFormFieldModule,
        MatNativeDateModule,
        NgxMaskModule.forChild()
    ],
    declarations: [
        BaseFormControlComponent,
        BaseInputComponent,
        LsqForm,
        LsqCheckboxComponent,
        SingleDateInputComponent,
        DateInputComponent,
        LsqChecklistComponent,
        LsqCurrencyInputComponent,
        LsqInputComponent,
        TagInputComponent,
        LsqRadioListComponent,
        LsqRadioComponent,
        LsqSelectComponent,
        LsqMultiSelectComponent,
        LsqPhoneInputComponent,
        LsqSwitchComponent,
        LsqTextAreaComponent,
        LsqDynamicFormComponent,
        CalendarDayComponent,
        CalendarDaysGridComponent,
        CalendarMonthComponent,
        CalendarMonthsGridComponent,
        CalendarComponent,
        DatePickerComponent,
        LsqDateSelectComponent,
        LsqDropdownComponent,
        LsqAutocompleteComponent,
        LsqLabelComponent
    ],
    exports: [
        // Modules
        ClickOutsideModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SingleDateInputComponent,
        DateInputComponent,

        TextMaskModule,
        NgxMaskModule,
        // Components
        BaseFormControlComponent,
        BaseInputComponent,
        LsqForm,
        LsqCheckboxComponent,
        LsqChecklistComponent,
        LsqCurrencyInputComponent,
        LsqInputComponent,
        TagInputComponent,
        LsqRadioListComponent,
        LsqRadioComponent,
        LsqSelectComponent,
        LsqMultiSelectComponent,
        LsqPhoneInputComponent,
        LsqSwitchComponent,
        LsqTextAreaComponent,
        LsqDynamicFormComponent,
        CalendarDayComponent,
        CalendarDaysGridComponent,
        CalendarMonthComponent,
        CalendarMonthsGridComponent,
        CalendarComponent,
        DatePickerComponent,
        LsqDateSelectComponent,
        LsqDropdownComponent,
        LsqAutocompleteComponent,
        LsqLabelComponent
    ],
    providers: [MatDatepickerModule, MatInputModule, MatFormFieldModule]
})
export class LsqFormsModule {
    constructor() {
        console.debug('Loading libs/LsqFormsModule.');
    }
}
